import React, { useEffect, useRef } from "react";
import { Editor, Frame, useEditor } from "@craftjs/core";
import { Container, Text, Image, Signature } from "../EditorNuevo/components/selectors";

const findNodeIdByContent = (contentJson, contentSubstring) => {
  if (!contentJson || typeof contentJson !== 'object') return null;

  for (const nodeId in contentJson) {
    const node = contentJson[nodeId];
    if (node.props && node.props.text && node.props.text.includes(contentSubstring)) {
      return nodeId;
    }
  }
  return null;
};

const InnerDeserializer = ({ contentJson, onReady }) => {
  const { actions, query } = useEditor();
  const mountedRef = useRef(false);

  
  useEffect(() => {
    mountedRef.current = true;
    if (!contentJson) return;

    try {
      actions.deserialize(contentJson);
    } catch (e) {
      console.error("[TemplateViewer] Error deserializing contentJson:", e);
    }

    const waitForReady = async () => {
      try {
        const el = document.getElementById("template-craft-viewer");
        if (!el) {
          console.warn("[TemplateViewer] contenedor no encontrado");
          if (mountedRef.current && typeof onReady === "function") onReady();
          return;
        }

        const imgs = Array.from(el.querySelectorAll("img"));
        const imgPromises = imgs.map(
          (img) =>
            new Promise((resolve) => {
              if (img.complete && img.naturalWidth !== 0) return resolve();
              const onEnd = () => {
                img.removeEventListener("load", onEnd);
                img.removeEventListener("error", onEnd);
                resolve();
              };
              img.addEventListener("load", onEnd);
              img.addEventListener("error", onEnd);
              setTimeout(resolve, 3000);
            })
        );

        const fontPromise = document.fonts ? document.fonts.ready : Promise.resolve();
        await Promise.all([fontPromise, ...imgPromises]);
      } catch (err) {
        console.warn("[TemplateViewer] waitForReady error:", err);
      } finally {
        if (mountedRef.current && typeof onReady === "function") {

          const tplObj = typeof contentJson === "string" ? JSON.parse(contentJson) : contentJson;
          const medicationsTextNodeId = findNodeIdByContent(tplObj, '{{listaMedicamentos}}');
          if (medicationsTextNodeId) {
            const parentId = tplObj[medicationsTextNodeId].parent;
                
            if (parentId) {                    
              actions.setProp(parentId, (props) => {
                props.height = 'auto';
              }, 0);
                    
              actions.setProp(medicationsTextNodeId, (props) => {
                props.text = props.text;
              }, 0);
            }
          }
          
          actions.setProp("ROOT", (props) => {
            props.height = 'auto';
          }, 0);
          onReady();
        }
      }
    };

    const t = setTimeout(waitForReady, 100);

    return () => {
      mountedRef.current = false;
      clearTimeout(t);
    };
  }, [contentJson, actions, onReady]);

  return null;
};

const TemplateViewer = ({ contentJson, widthMm = 210, heightMm = 297, onReady }) => {
  const containerStyle = {
    width: `${widthMm}mm`,
    minHeight: "auto",
    height: "auto",
    boxSizing: "border-box",
    background: "transparent",
    overflow: "visible"
  };

  return (
    <div id="template-craft-viewer" style={containerStyle}>
      <Editor resolver={{ Container, Text, Image, Signature }} enabled={false}>
        <Frame />
        <InnerDeserializer contentJson={contentJson} onReady={onReady} />
      </Editor>
    </div>
  );
};

export default TemplateViewer;
